{
  "name": "pokemon-auto-chess",
  "version": "4.4.0",
  "description": "",
  "keywords": [],
  "license": "BSD-3-Clause",
  "engines": {
    "node": "18.18.2"
  },
  "homepage": "https://github.com/keldaanCommunity/pokemonAutoChess#readme",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/keldaanCommunity/pokemonAutoChess.git"
  },
  "bugs": {
    "url": "https://github.com/keldaanCommunity/pokemonAutoChess/issues"
  },
  "author": "keldaan-ag",
  "contributors": [
    "ogus",
    "sylvainpolletvillard"
  ],
  "main": "public/dist/server/app/index.js",
  "scripts": {
    "reset": "rm -rf node_modules/ && rm -f app/public/js/*",
    "dev-client": "node esbuild.js --dev",
    "dev-server": "ts-node-dev --watch \"src/**/*\" --respawn --transpile-only ./app/index.ts",
    "dev": "npm-run-all --parallel dev-*",
    "lint": "npx eslint app/",
    "build-client": "node esbuild.js --build",
    "build-server": "tsc",
    "build": "npm run build-client && npm run build-server",
    "start": "node --optimize_for_size --max_old_space_size=800 ./app/public/dist/server/app/index.js",
    "add-bot": "node ./app/public/dist/server/db-commands/populate-bot.js",
    "monitor-bot": "node ./app/public/dist/server/scheduled/monitor-bot.js",
    "translate": "npx @inlang/cli machine translate -f",
    "pm2": "pm2 start ecosystem.config.js",
    "start-pm2": "npm run build && npm run pm2"
  },
  "dependencies": {
    "@colyseus/command": "^0.2.1",
    "@colyseus/monitor": "^0.15.1",
    "@colyseus/redis-driver": "^0.15.4",
    "@colyseus/redis-presence": "^0.15.4",
    "@colyseus/ws-transport": "^0.15.0",
    "@reduxjs/toolkit": "^1.9.7",
    "@types/bootstrap": "^5.2.7",
    "body-parser": "^1.20.1",
    "colyseus": "^0.15.9",
    "colyseus.js": "^0.15.14",
    "cors": "^2.8.5",
    "discord.js": "^14.13.0",
    "dotenv": "^16.3.1",
    "elo-rank": "^1.0.4",
    "express": "^4.18.2",
    "express-basic-auth": "^1.2.0",
    "express-openapi": "^12.1.3",
    "express-rate-limit": "^7.1.1",
    "fast-xml-parser": "^4.3.2",
    "firebase": "^10.4.0",
    "firebase-admin": "^11.11.0",
    "firebaseui": "^6.1.0",
    "graceful-fs": "^4.2.10",
    "i18next": "^23.5.1",
    "i18next-browser-languagedetector": "^7.1.0",
    "i18next-http-backend": "^2.2.2",
    "immer": "^10.0.3",
    "jimp": "^0.22.10",
    "loglevel": "^1.8.1",
    "marked": "^9.1.0",
    "matter-js": "^0.19.0",
    "mongoose": "^7.6.1",
    "nanoid": "^3.3.4",
    "nes.css": "^2.3.0",
    "pastebin-ts": "^1.3.0",
    "phaser": "^3.60.0",
    "phaser-animated-tiles-phaser3.5": "^2.0.5",
    "phaser3-rex-plugins": "^1.60.6",
    "react": "^18.2.0",
    "react-bootstrap": "^2.9.0",
    "react-bootstrap-typeahead": "^6.2.3",
    "react-circular-progressbar": "^2.1.0",
    "react-dom": "^18.2.0",
    "react-i18next": "^13.2.2",
    "react-pro-sidebar": "^1.1.0-alpha.1",
    "react-redux": "^8.1.3",
    "react-router-dom": "^6.16.0",
    "react-tabs": "^6.0.2",
    "react-toastify": "^9.1.1",
    "react-tooltip": "^5.21.5",
    "unique-names-generator": "^4.7.1"
  },
  "devDependencies": {
    "@babel/preset-env": "^7.22.20",
    "@babel/preset-react": "^7.22.15",
    "@types/cors": "^2.8.14",
    "@types/elo-rank": "^1.0.1",
    "@types/fs-extra": "^11.0.2",
    "@types/matter-js": "^0.19.1",
    "@types/react-dom": "^18.2.13",
    "@typescript-eslint/eslint-plugin": "^6.7.5",
    "@typescript-eslint/parser": "^6.7.5",
    "csv-writer": "^1.6.0",
    "esbuild": "^0.19.4",
    "eslint": "^8.51.0",
    "eslint-config-google": "^0.14.0",
    "eslint-plugin-react-hooks": "^4.6.0",
    "fs-extra": "^11.1.1",
    "npm-run-all": "^4.1.5",
    "openapi-typescript": "^6.7.0",
    "redux-devtools-extension": "^2.13.9",
    "ts-node-dev": "^2.0.0",
    "typescript": "^5.2.2"
  }
}
